export class EncryptionKeysLogsFilterCriteria {
  action: string;
  company: string;
  user: string;
  dateFrom: Date;
  dateTo: Date;

  constructor(userChoicesActiveFilters) {
    this.action = userChoicesActiveFilters.action;
    this.company = userChoicesActiveFilters.company;
    this.user = userChoicesActiveFilters.user;
    this.dateFrom = userChoicesActiveFilters.DateFrom;
    this.dateTo = userChoicesActiveFilters.DateTo;
  }
}
